import { IAppState } from '../../redux';
import { IRosreestrDataState } from '../../types/reducers/rosreestrData';

export const selectAutofields = (state: IAppState): IRosreestrDataState['autofields'] => {
  return state.rosreestrData.autofields;
};
